module.exports = __webpack_public_path__ + "img/newdataset_class.e12432df.png";